import { useEffect } from 'react'
import { setBalanceTopupHandler } from '../context/AuthContext'
import { useNotifications } from '../context/NotificationContext'

export default function NotificationBridge() {
  const { addNotification } = useNotifications()

  useEffect(() => {
    setBalanceTopupHandler((diff: number) => {
      addNotification(`Баланс пополнен на ${diff.toLocaleString('ru-RU')} токенов`, 'topup')
    })
    return () => setBalanceTopupHandler(() => {})
  }, [addNotification])

  return null
}